import React from 'react'
import DynamicPiechart from '../piechart.dashboard'
import { Row, Col, Table, Select, DatePicker } from 'antd'
import { oee_dashboard_output, oee_dashboard_shiftTime } from '../../../Utils/constants'

const LinePieChart = () => {
    return (
        <div>
            <Row className='oee-dashboard-row-5'>
                <Col className='oee-dashboard-row-5-col-1'>
                    <div className='output'>
                        <div className='left'>
                            <span className='head'>Output</span>
                            <div>
                                <div className='graph-info'>
                                    <div className='dot' style={{ backgroundColor: "#1E6EFE", width: "11px", height: "11px" }}></div>
                                    <span>Goods</span>
                                </div>
                                <div className='graph-info'>
                                    <div className='dot' style={{ backgroundColor: "#EB5757", width: "11px", height: "11px" }}></div>
                                    <span>Rejections</span>
                                </div>
                            </div>
                        </div>
                        <div className='graph'>
                            <DynamicPiechart
                                width={200}
                                height={200}
                                data={oee_dashboard_output}
                                dataKey="value"
                                text={<g>
                                    <text x={"50%"} y={"50%"} textAnchor="middle" style={{ fontSize: "12px", fontWeight: "bold" }}>Ideal Output</text>
                                    <text x={"50%"} y={"57%"} textAnchor="middle" style={{ fontSize: "10px", fontWeight: "bold" }}>234300</text>
                                </g>} />
                        </div>
                    </div>
                </Col>
                <Col className='oee-dashboard-row-5-col-2'>
                    <div className='shift-time'>
                        <div className='left'>
                            <div className='dflex flexColumn g10'>
                                <span className='head'>Shift Time</span>
                                <div className='dflex flexColumn' style={{ fontSize: "13px" }}>
                                    <span>Performance Downtime</span>
                                    <span className='boldText' style={{ marginTop: "-6px" }}>00:57:25</span>
                                </div>
                            </div>
                            <div>
                                <div className='graph-info'>
                                    <div className='dot' style={{ backgroundColor: "#1E6EFE", width: "11px", height: "11px" }}></div>
                                    <span>Operating Time</span>
                                </div>
                                <div className='graph-info'>
                                    <div className='dot' style={{ backgroundColor: "#EB5757", width: "11px", height: "11px" }}></div>
                                    <span>Availability Downtime</span>
                                </div>
                                <div className='graph-info'>
                                    <div className='dot' style={{ backgroundColor: "#1EA849", width: "11px", height: "11px" }}></div>
                                    <span>Planned Downtime</span>
                                </div>
                            </div>
                        </div>
                        <div className='graph'>
                            <DynamicPiechart
                                width={200}
                                height={200}
                                data={oee_dashboard_shiftTime}
                                dataKey="value" />
                        </div>
                    </div>
                </Col>
                <Col className='oee-dashboard-row-5-col-3'>
                    <div className='average-speedLineMonitor'>
                        <span className='head'>Average Speed</span>
                        <span className='value'>23.37</span>
                    </div>
                    <div className='bufferLineMonitor'>
                        <span className='head'>Buffer</span>
                        <span className='value'>8</span>
                    </div>
                    {/* <div className='shift-time'>
                        <span className='head'>Shift Time</span>
                        <span className='value'>09:00:00</span>
                    </div> */}
                </Col>
            </Row>
        </div>
    )
}

export default LinePieChart